// MiniCoaster.tsx - Redesigned with animations
import React from "react";
import { Link } from "react-router-dom";
import { ToasterProp } from "../../model";
import { motion } from "framer-motion";
import "./MiniCoaster.css";

const Mini_Coaster = (props: ToasterProp) => {
  // Animation variants
  const iconVariants = {
    hover: { 
      scale: 1.1,
      rotate: 5,
      transition: { 
        type: "spring", 
        stiffness: 300,
        duration: 0.3
      }
    }
  };

  const buttonVariants = {
    initial: { y: 0 },
    hover: { 
      y: -5,
      backgroundColor: "#ffeb3b", 
      borderColor: "#1a73e8",
      boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
      transition: { 
        type: "spring",
        stiffness: 400,
        duration: 0.3
      }
    },
    tap: { 
      scale: 0.95,
      y: 0
    }
  };

  return (
    <Link to={props.pathVar} className="mini-coaster-link">
      <motion.figure
        className="mini-coaster-figure"
        whileHover="hover"
        initial="initial"
      >
        <motion.div 
          className="circletag"
          variants={iconVariants}
        >
          <motion.img 
            src={props.picURL} 
            alt={props.title}
            initial={{ filter: "grayscale(0.3)" }}
            whileHover={{ filter: "grayscale(0)" }}
            style={{ width: '100px', height: '100px' }} /* Adjust size */

          />
          <motion.div 
            className="pulse-overlay"
            animate={{ 
              scale: [1, 1.1, 1],
              opacity: [0, 0.5, 0]
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: "loop"
            }}
          />
        </motion.div>
        <figcaption className="Coaster">
          <motion.button
            className="miniCoasterButton"
            variants={buttonVariants}
            whileTap="tap"
          >
            <motion.span
              initial={{ color: "#545454" }}
              whileHover={{ color: "#1a73e8" }}
            >
              <strong>{props.title}</strong>
            </motion.span>
          </motion.button>
        </figcaption>
      </motion.figure>
    </Link>
  );
};

export default Mini_Coaster;